<script>
  import Configuration from "../../config.js";

  export let onLogin;
  let username = "";
  let password = "";
  let errorMsg = "";
  let showPassword = false;
  let loading = false;

  function loginEnter(e) {
    if (e.charCode === 13) login();
  }

  async function login() {
    errorMsg = "";
    if (!username.trim() || !password.trim()) {
      errorMsg = "Ingrese credenciales";
      return;
    }
    loading = true;

    try {
      const conf = Configuration.getConfiguration();
      const res = await fetch(
        `${conf.ADMI_BO}/adminusers/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password }),
        },
      );

      if (!res.ok) throw new Error("Credenciales incorrectas");
      const data = await res.json();

      // SUPER_ADMIN always has access
      if (Number(data.rol) !== -1) {
        const token = data.access_token;
        const userId = data.id;
        if (token && userId) {
          const clientCode = data.client_code ?? data.clientCode ?? data.clientcode ?? null;

          // GESTOR_BONOS (role=null): solo verifica grupo
          if (data.rol == null) {
            if (!clientCode) throw new Error("No tienes acceso a Gestor Bonos");
            const res = await fetch(
              `${conf.ADMI_BO}/credentials?prefix=client_group.${clientCode}.views`,
              { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            const map = await res.json();
            if (!(`client_group.${clientCode}.views` in (map || {}))) {
              throw new Error("No tienes acceso a Gestor Bonos");
            }
          } else {
            // ADMIN (role=10): verifica am_views o grupo como fallback
            const [credRes, groupRes] = await Promise.all([
              fetch(
                `${conf.ADMI_BO}/credentials?prefix=am_views.${userId}`,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
              ),
              clientCode
                ? fetch(
                    `${conf.ADMI_BO}/credentials?prefix=client_group.${clientCode}.views`,
                    { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
                  )
                : Promise.resolve({ json: () => ({}) }),
            ]);
            const credMap = await credRes.json();
            const groupMap = await groupRes.json();
            const hasAmViews = `am_views.${userId}` in (credMap || {});
            const hasGroupViews = clientCode && (`client_group.${clientCode}.views` in (groupMap || {}));
            if (!hasAmViews && !hasGroupViews) {
              throw new Error("No tienes acceso a Gestor Bonos");
            }
          }
        }
      }

      // Guardar en sesión
      sessionStorage.setItem("user", JSON.stringify(data));
      // Avísale al padre que logueó correctamente
      onLogin(data);
    } catch (error) {
      errorMsg = error.message;
    } finally {
      loading = false;
    }
  }

  // Cuando se escribe en password, el botón aparece
  $: showToggle = password.length > 0;
  function togglePasswordVisibility() {
    showPassword = !showPassword;
  }
</script>

<div class="login-page">
  <div class="auth">
    <img
      width="150px"
      src="https://assets-usoft.universalsoft.net/bo_fontend/logo_small.png"
      alt="Logo"
    />
    <h2 class="title">Bienvenido a</h2>
    <h6 class="titleTwo">Gestor Bonos</h6>
    <span class="text-white">Acceso solo para usuarios autorizados</span>
    <div class="form-container">
      <div>
        <label class="text-white" for="username">Usuario*</label>
        <div class="input-group">
          <span class="input-group-text"><i class="fa-solid fa-user"></i></span>
          <input
            id="username"
            type="text"
            class="form-control"
            placeholder="Ingresa usuario"
            bind:value={username}
            on:keypress={loginEnter}
            autocomplete="off"
          />
        </div>
      </div>
      <div>
        <label class="text-white" for="password">Contraseña*</label>
        <div class="input-group">
          <span class="input-group-text"><i class="fa-solid fa-lock"></i></span>
          {#if showPassword}
            <input
              id="password"
              type="text"
              class="form-control"
              placeholder="Ingresa contraseña"
              bind:value={password}
              on:keypress={loginEnter}
              autocomplete="off"
            />
          {:else}
            <input
              id="password"
              type="password"
              class="form-control"
              placeholder="Ingresa contraseña"
              bind:value={password}
              on:keypress={loginEnter}
              autocomplete="off"
            />
          {/if}
          <button
            type="button"
            class="input-group-text toggle-btn"
            aria-label={showPassword
              ? "Ocultar contraseña"
              : "Mostrar contraseña"}
            on:click={togglePasswordVisibility}
          >
            <i
              class={showPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}
            ></i>
          </button>
        </div>
      </div>
      <button class="btn btn-primary" on:click={login} disabled={loading}>
        {#if loading}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Cargando...
        {:else}
          <i class="fa-solid fa-right-to-bracket" style="margin-right: 8px;"
          ></i> Ingresar
        {/if}
      </button>
    </div>
    {#if errorMsg}
      <p class="error">{errorMsg}</p>
    {/if}
  </div>
</div>

<style>
  .login-page {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("https://assets-usoft.universalsoft.net/bo_fontend/bggradient.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .auth {
    padding: 3rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    background: linear-gradient(
      209.33deg,
      rgba(153, 153, 153, 0.01) -56.94%,
      rgba(255, 255, 255, 0.02) 28.86%
    );
    border-radius: 2rem;
  }
  .auth:hover {
    box-shadow: rgba(244, 2, 140, 0.8) 0px 0px 80px 0px;
  }

  .form-container {
    /* max-width: 90%; */
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .title {
    margin-bottom: 0;
    font-weight: 700;
    font-size: 2rem;
    color: #ff007b;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }

  .titleTwo {
    margin-bottom: 0;
    font-weight: 700;
    font-size: 2rem;
    color: #FFFFFF;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  }

  .form-control {
    font-size: 1.2rem;
    padding: 1rem 1.2rem;
  }

  button.btn {
    width: 100%;
    border-radius: 7px;
    background: #ff007b;
    color: white;
    padding: 1rem;
    font-weight: 700;
    cursor: pointer;
    border: none;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }

  button.btn i {
    font-size: 1.5rem;
  }

  button.btn:hover {
    color: white !important;
    background: linear-gradient(90deg, #ff007b 0%, #000000 100%) !important;
  }
  .error {
    color: #ffffff;
  }
</style>
